import { render } from "./partnership-selector.vue?vue&type=template&id=990a7da8&ts=true"
import script from "./partnership-selector.ts?vue&type=script&lang=ts&external"
export * from "./partnership-selector.ts?vue&type=script&lang=ts&external"

import "./partnership-selector.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__